import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/criteriatopsport/";

const CriteriaTopsport = {
	get(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(beoordelingscriteria, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, {
			item: beoordelingscriteria,
			documenten
		}, {
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default CriteriaTopsport;
